import Vue from 'vue'
import { i18n } from '@/plugins/i18n'

let errorInterceptor = {
    type: 'response',

    process (response) {
        return response
    },

    exception (error) {
        if (error.message === 'Network Error') {
            Vue.swal(i18n.t('error.server-communication-error'))
        }

        if (error.response) {
            if ([500, 422, 405, 404, 401].indexOf(error.response.status) !== -1) {
                Vue.swal(i18n.t('error.unexpected-error'), error.response.statusText)
            }
        }

        return Promise.reject(error)
    }
}

export { errorInterceptor }
